/**
 * OrderLineStatusService
 * Service for OrderLineStatus entity operations
 * Route: api/orderlinestatuses
 * Controller: OrderLineStatusesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * OrderLineStatusService
 * Handles order line status CRUD operations
 * Maps to /api/orderlinestatuses endpoint
 */
export class OrderLineStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? OrderLineStatusService.DEFAULT_SERVICE_PATH,
            basePath: OrderLineStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate order line status cache
     * POST /api/orderlinestatuses/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate order line status cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
OrderLineStatusService.DEFAULT_SERVICE_PATH = 'orders';
OrderLineStatusService.BASE_PATH = 'api/orderlinestatuses';
//# sourceMappingURL=OrderLineStatusService.js.map